import { render, staticRenderFns } from "./clock-today-summary.vue?vue&type=template&id=86befaee"
import script from "./clock-today-summary.vue?vue&type=script&lang=js"
export * from "./clock-today-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports